import template from './selectMergeContactTypeModal.html';
import controller from './selectMergeContactTypeModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    clientsToMerge: '<',
    areMarriedCouples: '<',
    countryCode: '<',
    refreshContactList: '&',
  },
};
